import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ChevronsDownUp: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm7 20 5-5 5 5' }],
    ['path', { d: 'm7 4 5 5 5-5' }],
  ],
];

export default ChevronsDownUp;
